import {Card, DataStatus, Table, TableRow} from 'platform/components';
import {Box, Link, Text} from 'platform/foundation';
import {DateTimeFormat} from 'platform/locale';

import {descend, prop, sort} from 'ramda';

import {TestDriveResponseBody, useListTestDriveQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {businessCaseRoutes, customerRoutes} from '@dms/routes';
import {Main} from '@dms/shared';

import {composePath, parseDate, useRequiredParams} from 'shared/web';

export function TestDrives() {
  const {id: vehicleId} = useRequiredParams();
  const {
    data: testDrives,
    isLoading,
    isError,
  } = useListTestDriveQuery({
    vehicleId,
  });

  const sortedTestDrives = sort(
    descend(prop('scheduledAt')),
    (testDrives as TestDriveResponseBody[]) ?? []
  );

  return (
    <Main padding={0}>
      <Card title={i18n.t('entity.testDrive.labels.testDrives')}>
        <DataStatus
          isLoading={isLoading}
          isError={isError}
          isEmpty={!Boolean(sortedTestDrives?.length)}
          emptyMessage={i18n.t('entity.testDrive.labels.testDrivesEmpty')}
        >
          <Table>
            <TableRow>
              <Box paddingVertical={2} paddingHorizontal={3}>
                <Text size="small" alternative>
                  {i18n.t('general.labels.date')}
                </Text>
              </Box>
              <Box paddingVertical={2} paddingHorizontal={3}>
                <Text size="small" alternative>
                  {i18n.t('module.businessCase.title')}
                </Text>
              </Box>
              <Box paddingVertical={2} paddingHorizontal={3}>
                <Text size="small" alternative>
                  {i18n.t('module.customer.title')}
                </Text>
              </Box>
              <Box paddingVertical={2} paddingHorizontal={3}>
                <Text size="small" alternative>
                  {i18n.t('general.labels.employee')}
                </Text>
              </Box>
              <Box paddingVertical={2} paddingHorizontal={3}>
                <Text size="small" alternative>
                  {i18n.t('general.labels.note')}
                </Text>
              </Box>
            </TableRow>

            {sortedTestDrives?.map((testDrive) => (
              <TableRow key={testDrive.id}>
                <Box paddingVertical={2} paddingHorizontal={3}>
                  <Text size="small">
                    <DateTimeFormat
                      value={parseDate(testDrive.scheduledAt)}
                      format="dateTimeMedium"
                    />
                  </Text>
                </Box>
                <Box paddingVertical={2} paddingHorizontal={3}>
                  <Link
                    href={composePath(businessCaseRoutes.overview, {
                      params: {
                        id: testDrive.businessCaseId,
                      },
                    })}
                    leftIcon="action/open_in_new"
                    title={testDrive.businessCaseCode}
                    size="small"
                  />
                </Box>
                <Box paddingVertical={2} paddingHorizontal={3}>
                  <Link
                    href={composePath(customerRoutes.detail, {
                      params: {
                        id: testDrive.customerId,
                      },
                    })}
                    leftIcon="action/open_in_new"
                    title={`${testDrive.customerFoundingPersonFirstName} ${testDrive.customerFoundingPersonLastName}`}
                    size="small"
                  />
                </Box>
                <Box paddingVertical={2} paddingHorizontal={3}>
                  <Text size="small">
                    {testDrive.userFirstName} {testDrive.userLastName}
                  </Text>
                </Box>
                <Box maxWidth={120} paddingVertical={2} paddingHorizontal={3}>
                  <Text noWrap size="small">
                    {testDrive.note}
                  </Text>
                </Box>
              </TableRow>
            ))}
          </Table>
        </DataStatus>
      </Card>
    </Main>
  );
}
